/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado", "Domingo"], o = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"], t = "Anos", a = "Ano", n = "Mês", r = "Semana", s = "Dias", i = "Dia", c = "Hoje", d = "Sem eventos", m = "Dia inteiro", u = "Remover", v = "Criar um evento", D = "dddd D MMMM YYYY", y = {
  weekDays: e,
  months: o,
  years: t,
  year: a,
  month: n,
  week: r,
  days: s,
  day: i,
  today: c,
  noEvent: d,
  allDay: m,
  deleteEvent: u,
  createEvent: v,
  dateFormat: D
};
export {
  m as allDay,
  v as createEvent,
  D as dateFormat,
  i as day,
  s as days,
  y as default,
  u as deleteEvent,
  n as month,
  o as months,
  d as noEvent,
  c as today,
  r as week,
  e as weekDays,
  a as year,
  t as years
};
